import React, { useState } from "react"
import PropTypes from "prop-types"
import { Heading, Tooltip } from "@shopify/polaris"
import { ArrowRightMinor, CancelSmallMinor } from "@shopify/polaris-icons"
import Recommendations from "components/widgets/ImprovePage/Recommendations"
import { useTranslation } from "react-i18next"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
const KEY_TO_COMPONENT_KEY = {
  impact: "impact",
  complexity: "complexity",
  domain: "lever",
  key: "theme",
}

const RecommendationsGhgLayout = ({
  pillar,
  // kpiComponent,
  headingText,
  recommendations,
  theme,
  objective,
}) => {
  const { t } = useTranslation()
  const [showChart, setShowChart] = useState(false)

  const recommendationDescriptionGetter = (recommendation) => {
    let key = recommendation.lever

    return t(`recommendation:propositions.descriptions.${key}`)
  }

  const handleArrowClick = () => {
    setShowChart(true)
  }

  const handleCloseChart = () => {
    setShowChart(false)
  }

  return (
    <div
      className={`recommendationsLayout recommendationsLayout--${pillar} recommendationsLayout-ghg`}
    >
      {/* <div className="recommendationsLayout__score">{kpiComponent}</div> */}
      <div className="recommendationsLayout__recommendations">
        <Heading element="h1">{headingText}</Heading>

        <Recommendations
          pillar={pillar}
          objective={objective}
          theme={theme}
          recommendations={recommendations}
          keysToComponentKeys={KEY_TO_COMPONENT_KEY}
          canSelectRecommendationDetails
          recommendationDescriptionGetter={recommendationDescriptionGetter}
          sdgGetter={(recommendation) => recommendation.sdg}
        />
      </div>
      <div className="recommendationsLayout__chart">
        {!showChart ? (
          <Tooltip light content="visualize trajectory">
            <div
              className="recommendationsLayout__chart-arrow"
              onClick={handleArrowClick}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  handleArrowClick()
                }
              }}
            >
              <ArrowRightMinor />
            </div>
          </Tooltip>
        ) : (
          <div className="recommendationsLayout__chart-container">
            <Tooltip light content="Close trajectory">
              <button
                className="recommendationsLayout__chart-close"
                onClick={handleCloseChart}
                aria-label="Close trajectory"
              >
                <CancelSmallMinor />
              </button>
            </Tooltip>
            <div className="recommendationsLayout__chart-wrapper">
              <MetabaseChartMolecule verdikt_alias={"dashboard_simulations"} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

RecommendationsGhgLayout.propTypes = {
  pillar: PropTypes.string,
  // kpiComponent: PropTypes.element,
  headingText: PropTypes.string,
  recommendations: PropTypes.arrayOf(PropTypes.object),
  theme: PropTypes.string,
  objective: PropTypes.string,
}

RecommendationsGhgLayout.defaultProps = {
  pillar: "environmental",
  kpiComponent: null,
  headingText: null,
  recommendations: [],
  theme: null,
  objective: null,
}

export default RecommendationsGhgLayout
